import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { DeviceContext } from '../services/Context'
import { useDispatch } from 'react-redux'
import { Dispatch } from '../store'
import { InlineTextFieldSetting } from './InlineTextFieldSetting'
import { TestUI } from './TestUI'

export const DevicePresenceSetting: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<Dispatch>()
  const { device } = useContext(DeviceContext)

  if (!device) return null

  return (
    <TestUI>
      <InlineTextFieldSetting
        icon="bullseye-pointer"
        label={t('devicePresenceSetting.label', 'Presence Address')}
        placeholder="presence.remote.it:443"
        value={device.presenceAddress}
        disabled={!device.permissions.includes('MANAGE')}
        resetValue={device.presenceAddress}
        onSave={value =>
          dispatch.devices.cloudUpdatePresenceAddress({
            id: device.id,
            set: { presenceAddress: value?.toString() || '' },
          })
        }
      />
    </TestUI>
  )
}
